import { useTranslation } from "@i18n/hooks";
import {
	SelectMultipleRootNodesFieldProps,
	SelectMultipleRootNodesFieldState,
} from "./select-multiple-root-nodes-field.types";
import { SelectComplexDataField } from "../../../components/select-complex-data-field";

import { SearchablePublishedRootTable } from "../searchable-published-root-table";

export const SelectMultipleRootNodesField = ({ ...props }: SelectMultipleRootNodesFieldProps) => {
	const { t } = useTranslation("common");
	return (
		<>
			<SelectComplexDataField<SelectMultipleRootNodesFieldState>
				valuePlaceholder={t("course.noCoursesSelected")}
				actionButtonLabel={t("course.selectCourse")}
				headerLabel={t("course.selectAtLeastOneCourse")}
				{...props}
			>
				<SearchablePublishedRootTable
					selection={props.fieldValue}
					onChange={props.updateField}
					selectionMode="multiple"
				/>
			</SelectComplexDataField>
		</>
	);
};
